import { atomWithStorage } from "jotai/utils";

import aovColumns from "src/components/Analytics/AovAnalytics/aovColumns";

export default atomWithStorage("persistentAovAtom", {
  viewOptions: aovColumns.map((column) => ({
    name: column.title,
    value: column.viewByDefault,
  })),
});
